import Component from '@glimmer/component';
import { ParseResourceName } from 'core/utils/resource-name';
import Summary from 'core/components/core/card/summary';
import { t } from 'ember-intl';
import {
  HdsIcon,
  HdsCopySnippet,
  HdsTooltipButton,
  HdsCopyButton,
} from '@hashicorp/design-system-components/components';
import { Flex, Time } from 'core/components';
import { optionForSourceState } from 'core/helpers';

export default class IamServicePrincipalsSummaryCard extends Component {
  get truncatedResourceName() {
    const parsedResourceName = ParseResourceName(
      this.args.servicePrincipal.resourceName
    );

    if (!parsedResourceName) {
      return this.args.servicePrincipal.resourceName;
    }
    const { parts } = parsedResourceName;
    const name = parts[parts.length - 1][1];

    return `.../${name}`;
  }
  <template>
    <Summary
      @type="horizontal"
      data-test-service-principal-detail-summary-card
      as |Card|
    >
      <Card.Pair as |P|>
        <P.Key
          data-test-service-principal-detail-summary-card-key
          data-test-service-principal-detail-summary-card-key-type
        >
          {{t "components.iam.service-principals.summary-card.principal-type"}}
        </P.Key>
        <P.Value
          data-test-service-principal-detail-summary-card-value
          data-test-service-principal-detail-summary-card-value-type
        >
          {{#let
            (optionForSourceState "policy-type" "service-principal")
            as |option|
          }}
            <Flex @alignItems="center" @direction="row" @gap="xs">
              <span>
                <HdsIcon @name={{option.icon}} @isInline={{true}} />
              </span>
              <span>
                {{t option.text}}
              </span>
            </Flex>
          {{/let}}
        </P.Value>
      </Card.Pair>
      <Card.Pair as |P|>
        <P.Key
          data-test-service-principal-detail-summary-card-key
          data-test-service-principal-detail-summary-card-key-id
        >
          {{t "components.iam.service-principals.summary-card.id"}}
        </P.Key>
        <P.Value
          data-test-service-principal-detail-summary-card-value
          data-test-service-principal-detail-summary-card-value-id
        >
          <HdsCopySnippet
            @color="secondary"
            @textToCopy={{@servicePrincipal.id}}
          />
        </P.Value>
      </Card.Pair>
      <Card.Pair as |P|>
        <P.Key
          data-test-service-principal-detail-summary-card-key
          data-test-service-principal-detail-summary-card-key-resource-name
        >
          {{t "components.iam.service-principals.summary-card.resource-name"}}
        </P.Key>
        <P.Value
          data-test-service-principal-detail-summary-card-value
          data-test-service-principal-detail-summary-card-value-resource-name
        >
          {{#if @servicePrincipal.resourceName}}
            <Flex @alignItems="center" @direction="row" @gap="2xs">
              {{this.truncatedResourceName}}
              <HdsTooltipButton
                @text={{t
                  "components.iam.service-principals.summary-card.tooltip.text"
                  resourceName=@servicePrincipal.resourceName
                  htmlSafe=true
                }}
                aria-label={{t
                  "components.iam.service-principals.summary-card.tooltip.aria-label"
                }}
              >
                <HdsIcon @name="info" @isInline={{true}} />
              </HdsTooltipButton>
              <HdsCopyButton
                @isIconOnly={{true}}
                @size="small"
                @text={{t
                  "components.iam.service-principals.summary-card.resource-name"
                }}
                @textToCopy={{@servicePrincipal.resourceName}}
              />
            </Flex>
          {{else}}
            —
          {{/if}}
        </P.Value>
      </Card.Pair>
      <Card.Pair as |P|>
        <P.Key
          data-test-service-principal-detail-summary-card-key
          data-test-service-principal-detail-summary-card-key-created
        >
          {{t "components.iam.service-principals.summary-card.created"}}
        </P.Key>
        <P.Value
          data-test-service-principal-detail-summary-card-value
          data-test-service-principal-detail-summary-card-value-created
        >
          <Time
            @date={{@servicePrincipal.createdAt}}
            @display="friendly-only"
          />
        </P.Value>
      </Card.Pair>
    </Summary>
  </template>
}
